export const MARKET_BANNER_URL = '/api/proxy/content/marketBanner';
export const MARKET_GET_RELATIVE_URL = '/api/proxy/content/GetRelativeUrlFromCultureInfo';
